export const jawTeeth = {
  upperJaw: [17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27],
  lowerJaw: [47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37],
  fullMouth: [
    17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37,
  ],
  fullMouthGroups: [
    [18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28],
    [48, 47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37, 38],
  ],
};
